import { graphql, useStaticQuery } from "gatsby"

/**
 * One query, reused by every consumer of src/data/clientLogos.js (the
 * homepage marquee, About Us, every industry Trusted By section, and the
 * /caseStudies story cards) — Gatsby dedupes identical useStaticQuery
 * bodies, so calling this from several components doesn't repeat the
 * query at build time.
 *
 * Returns a lookup keyed by each file's path relative to
 * src/images/clients/ (matching src/data/clientLogos.js's own
 * `colorFile`/`grayFile` values exactly, Colored/ or gray/ prefix
 * included), each value `{ width, height, fluid }` — `width`/`height` are
 * the source file's own, real pixel dimensions (for aspect-ratio banding),
 * `fluid` is the responsive src/srcSet/sizes set Gatsby's sharp pipeline
 * generates from it (quality 82, up to 440px wide — 2x headroom over the
 * largest box, 220px).
 */
const useClientLogoImages = () => {
  const data = useStaticQuery(graphql`
    query ClientLogoImages {
      allFile(
        filter: {
          relativeDirectory: { in: ["clients", "clients/Colored", "clients/gray"] }
          extension: { in: ["jpg", "jpeg", "png"] }
        }
      ) {
        nodes {
          relativePath
          childImageSharp {
            original {
              width
              height
            }
            fluid(maxWidth: 440, quality: 82) {
              src
              srcSet
              sizes
              srcWebp
              srcSetWebp
            }
          }
        }
      }
    }
  `)

  const byPath = {}
  data.allFile.nodes.forEach(n => {
    if (!n.childImageSharp) return
    const relativeToClients = n.relativePath.replace(/^clients\//, "")
    byPath[relativeToClients] = {
      width: n.childImageSharp.original.width,
      height: n.childImageSharp.original.height,
      fluid: n.childImageSharp.fluid,
    }
  })
  return byPath
}

export default useClientLogoImages
